export const defaultGallery = [
  { src: "../pic/gallery8.jpg", alt: "מנה מהמטבח" },
  { src: "../pic/gallery9.jpg", alt: "בורגר טרי" },
  { src: "../pic/gallery10.jpg", alt: "מנה מהתפריט" },
  { src: "../pic/gallery14.jpg", alt: "אוכל מהגריל" },
  { src: "../pic/gallery13.jpg", alt: "מנה מיוחדת" },
  { src: "../pic/gallery12.jpg", alt: "תוספות" },
  { src: "../pic/gallery11.jpg", alt: "בורגרטיים" },
  { src: "../pic/gallery1.jpg", alt: "מטבח בשרי" },
  { src: "../pic/gallery2.jpg", alt: "מנה חמה" },
  { src: "../pic/gallery3.jpg", alt: "מהתפריט" },
  { src: "../pic/gallery5.jpg", alt: "בורגר על הפלנצ'ה" },
  { src: "../pic/gallery4.jpg", alt: "מנה מהסניף" },
  { src: "../pic/gallery7.jpg", alt: "אווירת המסעדה" },
  { src: "../pic/gallery6.jpg", alt: "מנה מהמטבח" },
  { src: "../pic/gallery15.jpg", alt: "בורגר טרי" },
  { src: "../pic/orders1.jpeg", alt: "הזמנה מהסניף" },
];

export const defaultHeroSlides = [
  { src: "../pic/gallery5.jpg", alt: "בורגרטיים על הגריל" },
  { src: "../pic/gallery10.jpg", alt: "מנה מהתפריט" },
  { src: "../pic/gallery7.jpg", alt: "אווירת הסניף" },
];

export const defaultStoryParagraphs = [
  "רשת בורגרטיים נוסדה בעקבות הביקוש למטבח בשרי איכותי בשומרון. האהבה שלנו לאוכל הפכה את החזון למציאות.",
  "התחלנו מפוד טראק כדי לפנק את החיילים באזור, וכיום לרשת בורגרטיים 6 סניפים בשומרון, התפריט המגוון ביותר ושירות משלוחים מהיר.",
  "בורגרטיים דוגלת במצוות הכנסת אורחים וטעם ישראלי אמיתי.",
];

export function createEmptyGalleryItem() {
  return { src: "../pic/logoround.png", alt: "תמונה חדשה" };
}

export function createEmptyHeroSlide() {
  return { src: "../pic/logoround.png", alt: "שקופית חדשה" };
}

export function createEmptyStoryParagraph() {
  return "פסקה חדשה — לחצו לעריכה";
}
